import React from "react";

const Hairline = () => (
    <div className="tw:h-px tw:w-full tw:bg-white/15" aria-hidden="true" />
);

const statCards = [
    {
        id: "experience",
        label: "Years\nof Experience",
        stat: "8+",
    },
    {
        id: "stores",
        label: "Shopify Stores\nDelivered",
        stat: "300+",
    },
    {
        id: "partner",
        label: "Official\nShopify Partner",
        stat: "100+",
        subtext: "5-Star Reviews",
    },
    {
        id: "team",
        label: "In-House\nTeam",
        stat: "70+",
    },
    {
        id: "ecommerce",
        label: "End-to-End\neCommerce",
        stat: "360°",
        subtext: "Branding to Growth",
    },
];

const StatCardItem = ({ card }) => (
    <article className="tw:flex tw:h-[360px] tw:sm:h-[400px] tw:xl:h-[480px] tw:3xl:h-[500px] tw:w-full tw:flex-col tw:justify-end tw:bg-[#2e2e2e] tw:p-6 tw:sm:p-7 tw:3xl:p-[32px]">
        <div className="tw:flex tw:w-full tw:flex-col tw:gap-4 tw:sm:gap-6 tw:xl:gap-8">
            <p className="tw:m-0 tw:whitespace-pre-line tw:font-helvetica-now tw:font-normal tw:leading-[1.25] tw:text-white tw:text-[clamp(1.125rem,1.5vw,1.563rem)]">
                {card.label}
            </p>

            <Hairline />

            <div className="tw:flex tw:flex-col tw:gap-1">
                <p className="tw:m-0 tw:font-medium tw:leading-[1.1] tw:text-white tw:text-[clamp(2rem,4vw,4rem)]">
                    {card.stat}
                </p>
                {card.subtext ? (
                    <p className="tw:m-0 tw:font-helvetica-now tw:text-sm tw:font-normal tw:text-white/60 tw:sm:text-base tw:xl:text-[18px]">
                        {card.subtext}
                    </p>
                ) : null}
            </div>
        </div>
    </article>
);

/**
 * "We are Abox" Stats Showcase — Figma Node 11233:3718
 */
const HomeWeAreSection = () => {
    return (
        <section
            className="tw:relative tw:w-full tw:overflow-hidden tw:bg-[#222] tw:px-5 tw:py-16 tw:md:px-10 tw:md:py-24 tw:xl:px-[100px] tw:xl:py-[180px]"
            aria-label="We are Abox"
        >
            <div className="new-service-container-full tw:relative tw:mx-auto tw:w-full">
                {/* Overlapping Top Heading */}
                <h2 className="tw:pointer-events-none tw:m-0 tw:select-none tw:text-[clamp(3.5rem,13vw,12.5rem)] tw:font-medium tw:leading-[90%] tw:text-white tw:opacity-90 tw:-mb-2 tw:sm:-mb-4 tw:lg:-mb-6 tw:xl:-mb-7 tw:pl-2 tw:sm:pl-4 tw:xl:pl-25">
                    We are
                </h2>

                {/* Cards Showcase */}
                <div className="tw:relative tw:z-10 tw:w-full">
                    {/* Mobile / Tablet — native rail, stays inside section px */}
                    <div className="tw:lg:hidden">
                        <div className="home-we-are-rail">
                            {statCards.map((card) => (
                                <div key={card.id} className="home-we-are-rail__slide">
                                    <StatCardItem card={card} />
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Desktop 5-Column Grid (lg+) */}
                    <div className="tw:hidden tw:grid-cols-5 tw:gap-4 tw:lg:grid tw:3xl:gap-6">
                        {statCards.map((card) => (
                            <StatCardItem key={card.id} card={card} />
                        ))}
                    </div>
                </div>

                {/* Overlapping Bottom Heading */}
                <h2 className="tw:pointer-events-none tw:m-0 tw:select-none tw:text-right tw:text-[clamp(3.5rem,13vw,12.5rem)] tw:font-medium tw:leading-[0.85] tw:tracking-[-0.03em] tw:text-white tw:opacity-90 tw:-mt-2 tw:sm:-mt-4 tw:lg:-mt-6 tw:xl:-mt-7 tw:pr-2 tw:sm:pr-4 tw:xl:pr-25">
                    Abox
                </h2>
            </div>
        </section>
    );
};

export default HomeWeAreSection;
